import React from 'react'
import FinishesCardContainer from './FinishesCardContainer'

const FinishesCard = props => <FinishesCardContainer {...props} />

export default FinishesCard
